const REGISTER_BIKE_URL =
  "https://docs.google.com/forms/d/18wd3l-W6fZCY38a98u_YsN_vlLdzFgxmcL2BoOBfcFw/viewform"

module.exports = {
  REGISTER_BIKE_URL,
}
